import { createFileRoute } from '@tanstack/react-router'

import EditSwadayaPage from '@/components/pages/backoffice/_ktg-penyuluh/swadaya/_swadayaId/_edit/containers/EditSwadayaPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/swadaya/$swadayaId/edit/'
)({
  component: EditSwadayaPage
})
